/* eslint-disable no-undef */
jQuery( function( $ ) {
	/* Completed Instruction Row Function */

	$( '.instruction-row' ).bind( 'click', function( e ) {
		e.preventDefault();

		if ( $( e.target ).is( 'button' ) ) {
			return;
		}

		$( this ).toggleClass( 'completed' );
	} );

	/* Countdown Timer Function */

	const interval = [];

	$( '.start-timer-button' ).on( 'click', function( e ) {
		e.preventDefault();

		const $time = $( this ).val();
		const $time2 = $time * 60;
		const timerID = $( this ).attr( 'id' );
		const display = $( this, '.timer-placeholder' );

		if ( $( this ).hasClass( 'stop-button' ) ) {
			clearInterval( interval[ timerID ] );
			$( this ).html( ankarsrumI18n.timer + ' ' ).removeClass( 'stop-button' );
			$( this, '.timer-placeholder' ).append( $time );
			$( this, '.timer-text-placeholder' ).append( ankarsrumI18n.time );
		}	else {
			$( this, 'timer-text-placeholder' ).addClass( 'stop-button' );
			startTimer( timerID, $time2, display );
		}
	} );

	function beepSound() {
		const beepPath = getTemplateValue.templateUrl + '/assets/sound/beep.mp3';
		const audio = new Audio( beepPath );
		audio.play();
	}

	function startTimer( intervalID, duration, display ) {
		let timer = duration,
			minutes, seconds;

		interval[ intervalID ] = setInterval( function() {
			minutes = parseInt( timer / 60, 10 );
			seconds = parseInt( timer % 60, 10 );

			seconds = 10 > seconds ? '0' + seconds : seconds;

			display.text( minutes + ':' + seconds );

			if ( 0 > --timer ) {
				beepSound();
				setTimeout( function() {
					// eslint-disable-next-line no-alert
					alert( ankarsrumI18n.finished );
					clearInterval( interval[ intervalID ] );
					display.text( ankarsrumI18n.reset );
				}, 200 );
			}
		}, 1000 );
	}
} );
